module.exports = __webpack_public_path__ + "d2ac7a6cb1a526972552e8dbc8e8db9f.svg";